export default __webpack_public_path__ + "static/media/Linux funda.8ea7a0d5.png";